import { AUTH_ERROR } from '../../../viewdocs/src/api/registerSession.js';
import { showErrorAlert } from './showErrorAlert.js';

export function checkShowErrorOtp(error) {
  const isInvalidCodeOtp = error?.toString().includes(AUTH_ERROR.OTP_INVALIDCODE);
  const message = isInvalidCodeOtp ? 'enrollment.sms_verify.invalid_otp' : error?.message;
  message ? showErrorAlert('global.error', message) : showErrorAlert();
}
